import { find, forEach, map, filter, max } from 'lodash'

const folderName = Wiz.globalSettings.globalConfig?.modelSetting?.folderName || ''
const EnumAPBTUV = 6 // UV属性绑定
const EnumKFTTReal2 = 2 // 二维向量(double2)类型

// 选中装置，将树节点转成node，并隐藏原来模型
const convertToNode = async (item, player) => {
  const deviceNode = await player.Native.ModelTree.convertToNode(item, false, false)
  await player.Native.ModelTree.createNodeItem({
    parentItem: 0,
    node: deviceNode,
    recursive: true,
    isTemplate: false,
  })
  return {
    node: deviceNode,
  }
}

/**
 * @description 拿到装置全部子节点，通过后端数据筛选出需要渲染流向的管线
 * @param {Array} nodeList 通过三维接口获取的当前装置的所有node节点列表
 * @param {String} nodeCode 需要渲染的模型位号
 * @returns {Object}
 */
const matchNodes = (nodeList, nodeCode) => {
  let flowPipeObj = {}
  const nodeObj = find(nodeList, ['name', nodeCode])
  if (nodeObj) {
    flowPipeObj = nodeObj
  }
  return flowPipeObj
}
/**
 * @description 匹配对应贴图
 * @param {Boolean} direction 流体方向
 * @param {String} materialType 对应三维文件名称
 * @returns {String} imgPath
 */
const matchImg = (direction, materialType) => {
  let imgPath = ''
  const str = direction ? 'l' : 'r'
  const basePath = 'data://../apps/'
  imgPath = `${basePath}${folderName}/dynamic/pipeFlow/${materialType}/8x-${materialType}-${str}.png`
  return imgPath
}

const formNodesImg = (nodesList, imgPath) => {
  const res = []
  for (let i = 0; i < nodesList.length; i += 1) {
    res.push({
      node: nodesList[i].nodePtr,
      imagePath: imgPath,
      color: 0xffffffff,
    })
  }
  return res
}

/**
 * 处理mixer和clip数据，clip使用nodeptr来保证唯一
 * @param {list} nodes node数据
 */
const formMixerClip = async (nodesList, mixerName) => {
  const res = []
  for (let i = 0; i < nodesList.length; i += 1) {
    res.push({
      mixer: mixerName,
      clipName: nodesList[i].nodePtr,
    })
  }
  return res
}

/**
 * 处理mixer和clip数据，clip使用nodeptr来保证唯一
 * @param {list} nodes node数据
 */
const formClipAction = (clipsList, mixerName) => {
  const res = []
  for (let i = 0; i < clipsList.length; i += 1) {
    res.push({
      mixer: mixerName,
      clip: clipsList[i],
    })
  }
  return res
}

/**
 * 批量向片段中添加轨道数据
 * @param {list} nodes node数据
 */
const formTracks = async (nodesList, clips) => {
  const res = []
  for (let i = 0; i < nodesList.length; i += 1) {
    const tempObj = {
      node: nodesList[i].nodePtr,
      clip: clips[i],
      trackParam: {
        trackType: EnumKFTTReal2,
        propertyLinkType: EnumAPBTUV,
      },
    }
    res.push(tempObj)
  }
  return res
}
/**
 * @description 根据材质贴图倍数，匹配不同的时间倍数
 * @param {String} multiple 当前材质贴图倍数
 * @returns
 */
const getMoveTime = (multiple) => {
  if (multiple === '2') {
    return 1
  }
  if (multiple === '4') {
    return 2
  }
  if (multiple === '8') {
    return 3
  }
  if (multiple === '16') {
    return 4
  }
  return 5
}
/**
 * 批量向片段中添加轨道数据
 * @param {list} nodeList node数据
 */
const formKeys = async (nodeList, trackList) => {
  const res = []
  const lFlow = [
    [0, 0],
    [1, 0],
  ]
  const rFlow = [
    [1, 0],
    [0, 0],
  ]
  for (let i = 0; i < nodeList.length; i += 1) {
    const time = getMoveTime(nodeList[i].multiple)
    const tempObj1 = {
      keyframeTrack: trackList[i],
      time: 0,
    }
    const tempObj2 = {
      keyframeTrack: trackList[i],
      time: time * 5,
    }
    if (nodeList[i].direction) {
      tempObj1.value = lFlow[0]
      tempObj2.value = lFlow[1]
    } else {
      tempObj1.value = rFlow[0]
      tempObj2.value = rFlow[1]
    }
    res.push(tempObj1)
    res.push(tempObj2)
  }
  return res
}

/**
 * 批量向片段中添加轨道数据
 * @param {list} nodesList node数据
 */
const formLoops = async (actionList, loop, repetition) => {
  const res = []
  for (let i = 0; i < actionList.length; i += 1) {
    res.push({
      action: actionList[i],
      loopMode: loop,
      repetitions: repetition,
    })
  }
  return res
}
const asyncFunc = async (nodeData) => {
  const mat = await player.Native.NodeProxy.getNodeMaterial(nodeData.nodePtr)
  let initialTexture = null
  if (mat !== 0) {
    initialTexture = await player.Native.NodeProxy.getMaterialTexture(mat)
  }
  return {
    initialTexture,
    mat,
    // code: nodeData.code,
  }
}
/**
 * @param {obj} nodeList 多个节点
 * @param {obj} player
 */
const batchNodesUV = async (nodeList, player, code) => {
  const result = []
  for (let j = 0; j < nodeList.length; j += 1) {
    result.push(await asyncFunc(nodeList[j]))
  }
  await Promise.all(result)
  const nodeDetailList = map(nodeList, (item) => {
    return {
      node: item.nodePtr,
      imagePath: item.imgPath,
      color: 0xffffffff,
    }
  })

  await player.Native.NodeProxy.batchSetNodesTexture(nodeDetailList) // 贴图
  // removeUselessNodes(nodes) // 将测点值不符合的剔出渲染列表
  // // mixer clip action
  const mixer = await player.Native.AnimationMixer.getMixer(code)
  const mixerClipList = map(nodeList, (item) => {
    return {
      mixer,
      clipName: item.nodePtr,
    }
  })
  const clipsList = await player.Native.AnimationClip.getBatchClips(mixerClipList)
  const clipActionList = map(clipsList, (item) => {
    return {
      mixer,
      clip: item,
    }
  })
  const actionList = await player.Native.AnimationAction.getBatchclipActions(clipActionList)
  // track
  await player.Native.KeyframeTrack.batchClearTrack(clipsList) // 可能造成云渲染黑屏
  const tracksParam = await formTracks(nodeList, clipsList)
  const trackList = await player.Native.KeyframeTrack.batchAddTracksWithParam(tracksParam)
  await player.Native.KeyframeTrack.batchKeyClear(trackList) // 可能造成云渲染黑屏
  const trackkeysList = await formKeys(nodeList, trackList)
  player.Native.KeyframeTrack.batchKeyAppend(trackkeysList)
  // play
  const loops = await formLoops(actionList, 1, -1)
  player.Native.AnimationAction.batchSetLoop(loops)
  player.Native.AnimationAction.batchPlay(actionList)
  return mixer
}
/**
 * @description 计算包围盒最长边
 * @param {Array} aabb 包围盒
 * @returns {Number} 返回包围盒最大长度
 */
const getAabbMaxLength = (aabb) => {
  const x = Math.abs(aabb[1][0] - aabb[0][0])
  const y = Math.abs(aabb[1][1] - aabb[0][1])
  const z = Math.abs(aabb[1][2] - aabb[0][2])
  return max([x, y, z])
}
/**
 * @description 获取当前长度所匹配的材质贴图倍数
 * @param {Number} length 长度
 */
const getMatchMultiple = (length) => {
  if (length <= 3) {
    return '2'
  }
  if (length > 3 && length <= 5) {
    return '4'
  }
  if (length > 5 && length <= 10) {
    return '8'
  }
  if (length > 10 && length <= 20) {
    return '16'
  }
  return '32'
}
/**
 * @description 筛选出当前节点以及其子节点所有有材质的节点
 * @param {Object} nodeData 节点数据
 * @param {Boolean} direction 方向
 * @param {String} materialType 材质贴图类型
 * @returns {Array}
 */
const asyncFunc2 = async (nodeData, direction, materialType, player) => {
  // 弯头需要做反向，并统一贴图尺寸
  const str = direction ? 'l' : 'r'
  const strNegative = !direction ? 'l' : 'r'
  const imgPathNegative = `data://../apps/${folderName}/dynamic/pipeFlow/${materialType}/2x-${materialType}-${strNegative}.png`
  const arr = []
  // item.name === 'Pipe' || item.name.indexOf('Degree') > -1
  // const tempMat = await player.Native.NodeProxy.getNodeMaterial(nodeData.nodePtr)
  if (nodeData.name.indexOf('Degree') > -1) {
    // 弯头
    const childList = await player.Native.NodeProxy.getNodeChildrenRecursion(nodeData.nodePtr)
    const aabb = await player.Native.NodeProxy.getAabb(nodeData.nodePtr)
    const length = getAabbMaxLength(aabb)
    if (childList?.length) {
      for (let i = 0; i < childList.length; i += 1) {
        const ttMat = await player.Native.NodeProxy.getNodeMaterial(childList[i].nodePtr)
        if (ttMat) {
          const copyMaterial = await player.Native.NodeProxy.copyMaterial(ttMat)
          player.Native.NodeProxy.setNodeMaterial(childList[i].nodePtr, copyMaterial)
          arr.push({
            ...childList[i],
            direction: !direction,
            imgPath: imgPathNegative,
            multiple: '2',
          })
        }
      }
    }
  } else {
    // 直管线
    const childList = await player.Native.NodeProxy.getNodeChildrenRecursion(nodeData.nodePtr)
    const aabb = await player.Native.NodeProxy.getAabb(nodeData.nodePtr)
    const length = getAabbMaxLength(aabb)
    const multiple = getMatchMultiple(length)
    if (childList?.length) {
      for (let j = 0; j < childList.length; j += 1) {
        const ttMat = await player.Native.NodeProxy.getNodeMaterial(childList[j].nodePtr)
        if (ttMat) {
          const copyMaterial = await player.Native.NodeProxy.copyMaterial(ttMat)
          player.Native.NodeProxy.setNodeMaterial(childList[j].nodePtr, copyMaterial)
          arr.push({
            ...childList[j],
            direction,
            imgPath: `data://../apps/${folderName}/dynamic/pipeFlow/${materialType}/${multiple}x-${materialType}-${str}.png`,
            multiple,
          })
        }
      }
    }
  }
  return arr
}

/**
 * @description 添加贴图，并配置动画
 * @param {Object} player
 * @param {Object} nodeInfo nodeptr，单个的node的信息
 * @param {String} materialType 材质文件类型
 * @param {Boolean} direction 流向
 */
const nodesUV = async (player, nodeInfo, materialType, direction, code) => {
  // let mat = 0
  let mixer
  // mat = await player.Native.NodeProxy.getNodeMaterial(nodeInfo.nodePtr)
  // let nodeAction = null
  // let initialTexture = null
  // if (mat === 0) {
  // 获取不到节点材质指针，检查是否还有子节点并判断子节点是否有材质指针，并批量添加流体动画
  const tempNodeList = await player.Native.NodeProxy.getNodeChildrenRecursion(nodeInfo.nodePtr)
  // 找到有材质的子节点
  const nodeList = []
  if (tempNodeList?.length) {
    // 找到管线下的
    const ttnodeList = filter(tempNodeList, (item) => {
      return item.name === 'Pipe' || item.name.indexOf('Degree') > -1
    })
    for (let i = 0; i < ttnodeList.length; i += 1) {
      nodeList.push(...(await asyncFunc2(ttnodeList[i], direction, materialType, player)))
    }
    await Promise.all(nodeList)
  }
  if (nodeList?.length) {
    mixer = await batchNodesUV(nodeList, player, code)
  }
  // }
  // else {
  //   initialTexture = await player.Native.NodeProxy.getMaterialTexture(mat)
  //   // 当管道是其他颜色时，可以先打个白色上去
  //   await player.Native.NodeProxy.setMaterialDiffuse(mat, 0xffffffff)
  //   await player.Native.NodeProxy.setMaterialTexture(mat, imgPath)
  //   let pathList = []
  //   if (direction) {
  //     pathList = [
  //       { time: 0, data: [0, 0] },
  //       { time: 1 * 5, data: [0, 1] },
  //     ]
  //   } else {
  //     pathList = [
  //       { time: 0, data: [0, 1] },
  //       { time: 1 * 5, data: [0, 0] },
  //     ]
  //   }
  //   // 创建路径动画混合器
  //   const mixer = await player.Native.AnimationMixer.getMixer('uv')
  //   const clip = await player.Native.AnimationClip.getClip(mixer, nodeInfo.nodePtr)
  //   const action = await player.Native.AnimationAction.clipAction(mixer, clip)
  //   nodeAction = action
  //   const clipTrackCount = await player.Native.KeyframeTrack.trackCount(clip)
  //   if (clipTrackCount > 0) {
  //     await player.Native.KeyframeTrack.clearTrack(clip)
  //   }
  //   // 创建关键帧轨道
  //   const trackC = await player.Native.KeyframeTrack.addTrackWithParam(clip, nodeInfo.nodePtr, {
  //     name: 'trackLocalColor',
  //     trackType: EnumKFTTReal2,
  //     propertyLinkType: EnumAPBTUV,
  //   })
  //   await player.Native.KeyframeTrack.keyClear(trackC)
  //   for (let i = 0; i < pathList.length; i += 1) {
  //     // 添加位置关键帧
  //     player.Native.KeyframeTrack.keyAppend(trackC, pathList[i].time, pathList[i].data)
  //   }
  //   // 获取动画片段控制器
  //   // 绑定动画片段更新通知
  //   player.Native.AnimationAction.bindActionUpdate(action)
  //   // 设置为循环模式播放
  //   player.Native.AnimationAction.setLoop(action, 1, -1)
  //   player.Native.AnimationAction.play(action)
  // }
  return mixer
}

export { convertToNode, matchNodes, matchImg, nodesUV, batchNodesUV }
